module.exports = __webpack_public_path__ + "img/强沙尘暴.355d8255.png";